webpackJsonp([25],{

/***/ 1056:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1129),
  /* template */
  __webpack_require__(1178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73285423",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a"><stop stop-color="#79D5CC" offset="0%"/><stop stop-color="#B0E4A9" offset="100%"/></linearGradient><linearGradient x1="50%" y1="1.977%" x2="50%" y2="100%" id="b"><stop stop-color="#00E8FF" offset="0%"/><stop stop-color="#B0E4A9" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="#002D3D" d="M0 0h100v100H0z"/><g opacity=".499" transform="rotate(-45 64.116 15.92)" fill="url(#a)"><path opacity=".197" d="M.085 59.989h59.904V.085H.085z"/><path opacity=".2" d="M12.565 47.509h34.944V12.565H12.565z"/><path opacity=".201" d="M22 37h15V22H22z"/></g><g opacity=".402" transform="rotate(-45 64.116 15.92)" stroke="url(#b)" stroke-width="1.25"><path d="M.71 59.364h58.654V.71H.71v58.654z" opacity=".197"/><path d="M13.19 46.884h33.694V13.19H13.19v33.694z" opacity=".2"/><path d="M22.625 36.375h13.75v-13.75h-13.75v13.75z" opacity=".201"/></g></g></svg>'};

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(38);

var _keys2 = _interopRequireDefault(_keys);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'specification',
  props: {
    properties: {
      type: Object,
      default: {}
    }
  },
  computed: {
    attributes: function attributes() {
      var firstKey = (0, _keys2.default)(this.properties)[0] || '';
      var attributes = this.properties[firstKey] || {};
      return (0, _get2.default)(attributes, 'attributes');
    }
  }
};

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Label = __webpack_require__(927);

var _Label2 = _interopRequireDefault(_Label);

var _Subheading = __webpack_require__(1164);

var _Subheading2 = _interopRequireDefault(_Subheading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-header',
  components: {
    NodeLabel: _Label2.default,
    FieldSubheading: _Subheading2.default
  },
  props: ['node'],
  computed: {
    title: function title() {
      if ((0, _get2.default)(this, 'node.default_head')) {
        return (0, _get2.default)(this, 'node.default_head');
      }
      return (0, _get2.default)(this, 'node.title', '');
    }
  }
};

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _icon_default_avater = __webpack_require__(1117);

var _icon_default_avater2 = _interopRequireDefault(_icon_default_avater);

var _Date = __webpack_require__(1095);

var _Date2 = _interopRequireDefault(_Date);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'author-pane',
  props: ['node'],
  mixins: [_section2.default],
  components: {
    FieldDate: _Date2.default,
    SvgDefaultAvater: _icon_default_avater2.default,
    TermLink: _Link2.default
  },
  computed: {
    sections: function sections() {
      var _this = this;

      var sections = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.sections', []), function (sectionLineage) {
        var sectionList = (0, _map2.default)(sectionLineage, _this.$store.getters.term);
        sections.push(sectionList);
      });
      return sections;
    },
    authorStyle: function authorStyle() {
      return { borderColor: this.sectionColor };
    },
    authors: function authors() {
      return (0, _map2.default)((0, _get2.default)(this, 'node.authors', []), this.$store.getters.term);
    },
    author: function author() {
      return this.$store.getters.term((0, _get2.default)(this, 'node.authors[0]'));
    },
    authorImage: function authorImage() {
      if (this.authors.length > 1) {
        return false;
      }
      return (0, _get2.default)(this, 'author.images[0].style_500x500');
    }
  }
};

/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    subheading: {
      type: String,
      default: ''
    }
  }
};

/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-subheading{color:#fff;font-weight:400;line-height:1.75rem;font-size:1.375rem}", "", {"version":3,"sources":["/app/components/node/fields/Subheading.vue"],"names":[],"mappings":"AAgCA,oBACE,WAAa,AACb,gBAAqB,AACrB,oBAAqB,AACrB,kBAAoB,CACrB","file":"Subheading.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-subheading {\n  color: white;\n  font-weight: initial;\n  line-height: 1.75rem;\n  font-size: 1.375rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".specification{font-family:Roboto,sans-serif}.specification__title{font-family:Barlow,sans-serif;font-weight:700;color:#f8008e;line-height:26px;text-transform:uppercase;font-size:1.25rem}.specification__content{color:#666;margin-top:22px;font-size:1.125rem}@media (min-width:1024px){.specification__content{margin-top:5px}}.specification__content>div:last-child{margin-bottom:20px}.specification__content__title{text-transform:capitalize;font-weight:700;line-height:24px;margin-top:20px}@media (min-width:1024px){.specification__content__title{line-height:15px;margin-top:14px;font-size:.75rem}}.specification__content__title:after{content:\":\";margin-left:-3px}.specification__content__text{line-height:24px}@media (min-width:1024px){.specification__content__text{line-height:18px;font-size:.875rem}}@media (min-width:1024px){.specification .col-12{max-width:15rem}}", "", {"version":3,"sources":["/app/components/article/Specification.vue"],"names":[],"mappings":"AAgCA,eACE,6BAAkC,CACnC,AACD,sBACI,8BAAkC,AAClC,gBAAkB,AAClB,cAAe,AACf,iBAAkB,AAClB,yBAA0B,AAC1B,iBAAmB,CACtB,AACD,wBACI,WAAe,AACf,gBAAiB,AACjB,kBAAoB,CAEvB,AACD,0BACA,wBACQ,cAAgB,CACvB,CACA,AACD,uCACM,kBAAoB,CACzB,AACD,+BACM,0BAA2B,AAC3B,gBAAkB,AAClB,iBAAkB,AAClB,eAAiB,CAEtB,AACD,0BACA,+BACU,iBAAkB,AAClB,gBAAiB,AACjB,gBAAmB,CAC5B,CACA,AACD,qCACQ,YAAa,AACb,gBAAkB,CACzB,AACD,8BACM,gBAAkB,CAEvB,AACD,0BACA,8BACU,iBAAkB,AAClB,iBAAoB,CAC7B,CACA,AAID,0BACA,uBACQ,eAAiB,CACxB,CACA","file":"Specification.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.specification {\n  font-family: \"Roboto\", sans-serif;\n}\n.specification__title {\n    font-family: \"Barlow\", sans-serif;\n    font-weight: bold;\n    color: #F8008E;\n    line-height: 26px;\n    text-transform: uppercase;\n    font-size: 1.25rem;\n}\n.specification__content {\n    color: #666666;\n    margin-top: 22px;\n    font-size: 1.125rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.specification__content {\n        margin-top: 5px;\n}\n}\n.specification__content > div:last-child {\n      margin-bottom: 20px;\n}\n.specification__content__title {\n      text-transform: capitalize;\n      font-weight: bold;\n      line-height: 24px;\n      margin-top: 20px;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.specification__content__title {\n          line-height: 15px;\n          margin-top: 14px;\n          font-size: 0.75rem;\n}\n}\n.specification__content__title:after {\n        content: ':';\n        margin-left: -3px;\n}\n.specification__content__text {\n      line-height: 24px;\n      /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.specification__content__text {\n          line-height: 18px;\n          font-size: 0.875rem;\n}\n}\n.specification .col-12 {\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.specification .col-12 {\n        max-width: 15rem;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".author-pane[data-v-73285423]{font-family:Barlow,sans-serif}@media (min-width:1024px){.author-pane[data-v-73285423]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:.9375rem;padding-top:.9375rem}}@media (min-width:0) and (max-width:1023px){.author-pane[data-v-73285423]{text-align:center;margin-top:-2.5625rem}}.author-list[data-v-73285423]{color:#002e3e;font-size:.875rem;line-height:1rem;padding-bottom:.1875rem}.author-list a[data-v-73285423]{font-weight:700;color:#002e3e}.author-list .authors[data-v-73285423]{display:inline-block;text-align:left}.author-list .authors[data-v-73285423]:before{content:\"by \"}.author-list .authors .author-name[data-v-73285423]{display:inline;padding-top:5px;text-align:left}.author-list .authors .author-name[data-v-73285423]:nth-child(n+2){margin-left:1.0625rem}.author-mask[data-v-73285423],.image-border-mask[data-v-73285423]{overflow:hidden}@media (min-width:1024px){.author-mask[data-v-73285423],.image-border-mask[data-v-73285423]{width:57px;height:57px}}@media (min-width:0) and (max-width:1023px){.author-mask[data-v-73285423],.image-border-mask[data-v-73285423]{width:76.3px;height:76.3px}}.author-mask[data-v-73285423]{-webkit-box-sizing:content-box;box-sizing:content-box;border-width:.1875rem;border-style:solid;background-color:#ccc;overflow:hidden;-webkit-transform:translateZ(0) rotate(45deg);transform:translateZ(0) rotate(45deg)}.author-mask .image[data-v-73285423]{-webkit-transform:rotate(-45deg) translateY(-22px);-ms-transform:rotate(-45deg) translateY(-22px);transform:rotate(-45deg) translateY(-22px)}@media (min-width:1024px){.author-mask .image[data-v-73285423]{width:5.625rem;height:5.625rem}}@media (min-width:0) and (max-width:1023px){.author-mask[data-v-73285423]{display:inline-block;margin-bottom:1rem}.author-mask .image[data-v-73285423]{width:6.75rem;height:6.75rem}}@media (min-width:1024px){.author-info[data-v-73285423]{margin-left:-.9375rem;margin-top:1rem}.author-info .published-date[data-v-73285423]{text-align:left}}", "", {"version":3,"sources":["/app/components/node/AuthorPane.vue"],"names":[],"mappings":"AAgCA,8BACE,6BAAkC,CAGnC,AACD,0BACA,8BACM,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,oBAAuB,CAC5B,CACA,AACD,4CACA,8BACM,kBAAmB,AACnB,qBAAuB,CAC5B,CACA,AACD,8BACE,cAAe,AACf,kBAAoB,AACpB,iBAAkB,AAClB,uBAA0B,CAC3B,AACD,gCACI,gBAAkB,AAClB,aAAe,CAClB,AACD,uCACI,qBAAsB,AACtB,eAAiB,CACpB,AACD,8CACM,aAAe,CACpB,AACD,oDACM,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACtB,AACD,mEACQ,qBAAuB,CAC9B,AACD,kEAEE,eAAiB,CAGlB,AACD,0BACA,kEAEM,WAAY,AACZ,WAAa,CAClB,CACA,AACD,4CACA,kEAEM,aAAc,AACd,aAAe,CACpB,CACA,AACD,8BACE,+BAAgC,AACxB,uBAAwB,AAChC,sBAAwB,AACxB,mBAAoB,AACpB,sBAA0B,AAC1B,gBAAiB,AACjB,8CAAiD,AACzC,qCAAyC,CAGlD,AACD,qCACI,mDAAoD,AAChD,+CAAgD,AAC5C,0CAA4C,CACvD,AACD,0BACA,qCACM,eAAgB,AAChB,eAAiB,CACtB,CACA,AACD,4CACA,8BACM,qBAAsB,AACtB,kBAAoB,CACzB,AACD,qCACQ,cAAe,AACf,cAAgB,CACvB,CACA,AAID,0BACA,8BACM,sBAAwB,AACxB,eAAiB,CACtB,AACD,8CACQ,eAAiB,CACxB,CACA","file":"AuthorPane.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.author-pane[data-v-73285423] {\n  font-family: \"Barlow\", sans-serif;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.author-pane[data-v-73285423] {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-left: 0.9375rem;\n      padding-top: 0.9375rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.author-pane[data-v-73285423] {\n      text-align: center;\n      margin-top: -2.5625rem;\n}\n}\n.author-list[data-v-73285423] {\n  color: #002E3E;\n  font-size: 0.875rem;\n  line-height: 1rem;\n  padding-bottom: 0.1875rem;\n}\n.author-list a[data-v-73285423] {\n    font-weight: bold;\n    color: #002E3E;\n}\n.author-list .authors[data-v-73285423] {\n    display: inline-block;\n    text-align: left;\n}\n.author-list .authors[data-v-73285423]:before {\n      content: 'by ';\n}\n.author-list .authors .author-name[data-v-73285423] {\n      display: inline;\n      padding-top: 5px;\n      text-align: left;\n}\n.author-list .authors .author-name[data-v-73285423]:nth-child(n+2) {\n        margin-left: 1.0625rem;\n}\n.image-border-mask[data-v-73285423],\n.author-mask[data-v-73285423] {\n  overflow: hidden;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.image-border-mask[data-v-73285423],\n    .author-mask[data-v-73285423] {\n      width: 57px;\n      height: 57px;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.image-border-mask[data-v-73285423],\n    .author-mask[data-v-73285423] {\n      width: 76.3px;\n      height: 76.3px;\n}\n}\n.author-mask[data-v-73285423] {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  border-width: 0.1875rem;\n  border-style: solid;\n  background-color: #cccccc;\n  overflow: hidden;\n  -webkit-transform: translateZ(0px) rotate(45deg);\n          transform: translateZ(0px) rotate(45deg);\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.author-mask .image[data-v-73285423] {\n    -webkit-transform: rotate(-45deg) translateY(-22px);\n        -ms-transform: rotate(-45deg) translateY(-22px);\n            transform: rotate(-45deg) translateY(-22px);\n}\n@media (min-width: 1024px) {\n.author-mask .image[data-v-73285423] {\n      width: 5.625rem;\n      height: 5.625rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.author-mask[data-v-73285423] {\n      display: inline-block;\n      margin-bottom: 1rem;\n}\n.author-mask .image[data-v-73285423] {\n        width: 6.75rem;\n        height: 6.75rem;\n}\n}\n.author-info[data-v-73285423] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.author-info[data-v-73285423] {\n      margin-left: -0.9375rem;\n      margin-top: 1rem;\n}\n.author-info .published-date[data-v-73285423] {\n        text-align: left;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-header-wrapper[data-v-73e7b9c3]{background:#000}.article-header[data-v-73e7b9c3]{padding-bottom:3.5625rem;padding-top:4.125rem;font-family:Barlow,sans-serif}@media (min-width:0) and (max-width:1023px){.article-header[data-v-73e7b9c3]{padding-left:1.25rem;padding-right:1.25rem}}.article-header[data-v-73e7b9c3] .node-label{color:#fceb40;text-transform:uppercase}@media (min-width:0) and (max-width:1023px){.article-header[data-v-73e7b9c3] .node-label{font-size:1rem;line-height:1.25rem;font-weight:700}}.article-header[data-v-73e7b9c3] .node-label .fields,.article-header[data-v-73e7b9c3] .node-label .icon-wrapper{display:inline-block}@media (min-width:0) and (max-width:1023px){.article-header[data-v-73e7b9c3] .node-label .icon-wrapper--photo{position:relative;top:-.0625rem}}.article-title[data-v-73e7b9c3]{font-family:Barlow,sans-serif;font-size:2.125rem;color:#fff;font-weight:700;line-height:2.5rem}", "", {"version":3,"sources":["/app/components/node/ArticleHeader.vue"],"names":[],"mappings":"AAgCA,yCACE,eAAoB,CACrB,AACD,iCACE,yBAA0B,AAC1B,qBAAsB,AACtB,6BAAkC,CAEnC,AACD,4CACA,iCACM,qBAAsB,AACtB,qBAAuB,CAC5B,CACA,AACD,6CACI,cAAe,AACf,wBAA0B,CAE7B,AACD,4CACA,6CACQ,eAAgB,AAChB,oBAAqB,AACrB,eAAkB,CACzB,CACA,AACD,gHACM,oBAAsB,CAC3B,AAID,4CACA,kEACU,kBAAmB,AACnB,aAAgB,CACzB,CACA,AACD,gCACE,8BAAkC,AAClC,mBAAoB,AACpB,WAAe,AACf,gBAAkB,AAClB,kBAAoB,CACrB","file":"ArticleHeader.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-header-wrapper[data-v-73e7b9c3] {\n  background: #000000;\n}\n.article-header[data-v-73e7b9c3] {\n  padding-bottom: 3.5625rem;\n  padding-top: 4.125rem;\n  font-family: \"Barlow\", sans-serif;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-header[data-v-73e7b9c3] {\n      padding-left: 1.25rem;\n      padding-right: 1.25rem;\n}\n}\n.article-header[data-v-73e7b9c3] .node-label {\n    color: #FCEB40;\n    text-transform: uppercase;\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-header[data-v-73e7b9c3] .node-label {\n        font-size: 1rem;\n        line-height: 1.25rem;\n        font-weight: bold;\n}\n}\n.article-header[data-v-73e7b9c3] .node-label .fields, .article-header[data-v-73e7b9c3] .node-label .icon-wrapper {\n      display: inline-block;\n}\n.article-header[data-v-73e7b9c3] .node-label .icon-wrapper--photo {\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-header[data-v-73e7b9c3] .node-label .icon-wrapper--photo {\n          position: relative;\n          top: -0.0625rem;\n}\n}\n.article-title[data-v-73e7b9c3] {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 2.125rem;\n  color: #FFFFFF;\n  font-weight: bold;\n  line-height: 2.5rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("18fc0df2", content, true, {});

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1139);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("2d43dca9", content, true, {});

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1140);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("3ff100dc", content, true, {});

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("c680d4da", content, true, {});

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1124),
  /* template */
  __webpack_require__(1177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1131),
  /* template */
  __webpack_require__(1173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.subheading) ? _c('p', {
    staticClass: "article-subheading"
  }, [_vm._v("\n  " + _vm._s(_vm.subheading) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specification row no-gutters"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "specification__title"
  }, [_vm._v("\n      SPECIFICATIONS\n    ")]), _c('div', {
    staticClass: "specification__content"
  }, _vm._l((_vm.attributes), function(item, index) {
    return (item.value) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "specification__content__title"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]), _c('div', {
      staticClass: "specification__content__text"
    }, [_vm._v("\n          " + _vm._s(item.value) + "\n        ")])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author-pane"
  }, [_c('div', {
    staticClass: "author-mask",
    style: (_vm.authorStyle)
  }, [_c('div', {
    staticClass: "image-border-mask"
  }, [(_vm.authorImage) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.authorImage),
      expression: "authorImage"
    }],
    staticClass: "author-image image grayscale"
  }) : _c('svg-default-avater', {
    staticClass: "author-image image",
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  })], 1)]), _c('div', {
    staticClass: "author-info"
  }, [(_vm.author.title) ? _c('div', {
    staticClass: "author-list"
  }, [(_vm.authors) ? _c('div', {
    staticClass: "authors"
  }, _vm._l((_vm.authors), function(author, key) {
    return _c('div', {
      staticClass: "author-name"
    }, [_c('term-link', {
      attrs: {
        "tid": author.tid,
        "title": author.title,
        "url": author.relative_url,
        "type": author.type
      }
    }, [_vm._v("\n            " + _vm._s(author.title) + "\n          ")]), _c('br')], 1)
  })) : _vm._e()]) : _vm._e(), _c('field-date', {
    attrs: {
      "node": _vm.node
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-header-wrapper"
  }, [_c('div', {
    staticClass: "container article-header"
  }, [_c('node-label', {
    attrs: {
      "node": _vm.node
    }
  }), (_vm.title) ? _c('div', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('field-subheading', {
    attrs: {
      "subheading": _vm.node.subheading
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _without = __webpack_require__(1661);

var _without2 = _interopRequireDefault(_without);

var _split = __webpack_require__(345);

var _split2 = _interopRequireDefault(_split);

var _trim = __webpack_require__(246);

var _trim2 = _interopRequireDefault(_trim);

var _join = __webpack_require__(384);

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bind: function bind(element, binding) {
    var isWrapper = (0, _get2.default)(binding, 'value', false) === 'wrapper';
    var tagetImg = isWrapper ? element.firstElementChild : element;

    tagetImg.onload = function () {
      var orientation = '';
      var ratio = this.width / this.height;
      if (ratio < 1) {
        orientation = 'portrait';
      } else {
        orientation = 'landscape';
        if (ratio === 1) orientation = 'square';

        if (isWrapper) {
          element.style['min-height'] = this.height + 'px';
        }
      }

      var classList = (0, _split2.default)((0, _trim2.default)((0, _get2.default)(element, 'classList.value', '')), ' ');
      element.classList = (0, _join2.default)((0, _without2.default)(classList, 'portrait', 'landscape', 'square'), ' ') + ' ' + orientation;
    };
  }
};

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _Specification = __webpack_require__(1159);

var _Specification2 = _interopRequireDefault(_Specification);

var _imageOrientation = __webpack_require__(1184);

var _imageOrientation2 = _interopRequireDefault(_imageOrientation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'product-pane',
  props: ['product'],
  mixins: [],
  components: {
    SpecificationPane: _Specification2.default,
    NodeLink: _Link2.default
  },
  directives: {
    ImageOrientation: _imageOrientation2.default
  },
  computed: {
    properties: function properties() {
      return (0, _get2.default)(this, 'product.product.properties', {});
    },
    image: function image() {
      var originalProductImage = (0, _get2.default)(this, 'product.product.images[0].style_650w', '');
      var comparisonProductImage = (0, _get2.default)(this, 'product.images[0].style_650w', '');
      return comparisonProductImage !== '' ? comparisonProductImage : originalProductImage;
    },
    reviewArticleNode: function reviewArticleNode() {
      return (0, _get2.default)(this, 'product.review_article.id', false) ? this.$store.getters.node(this.product.review_article.id) : false;
    }
  },
  methods: {
    get: _get2.default
  }
};

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _clone = __webpack_require__(243);

var _clone2 = _interopRequireDefault(_clone);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _Label = __webpack_require__(927);

var _Label2 = _interopRequireDefault(_Label);

var _AuthorPane = __webpack_require__(1056);

var _AuthorPane2 = _interopRequireDefault(_AuthorPane);

var _SharePane = __webpack_require__(340);

var _SharePane2 = _interopRequireDefault(_SharePane);

var _ProductPane = __webpack_require__(1700);

var _ProductPane2 = _interopRequireDefault(_ProductPane);

var _ArticleHeader = __webpack_require__(982);

var _ArticleHeader2 = _interopRequireDefault(_ArticleHeader);

var _Tag = __webpack_require__(983);

var _Tag2 = _interopRequireDefault(_Tag);

var _Body = __webpack_require__(951);

var _Body2 = _interopRequireDefault(_Body);

var _InlineNewsletterForm = __webpack_require__(1057);

var _InlineNewsletterForm2 = _interopRequireDefault(_InlineNewsletterForm);

var _BodyHead = __webpack_require__(1003);

var _BodyHead2 = _interopRequireDefault(_BodyHead);

var _ComparisonProductCarousel = __webpack_require__(1711);

var _ComparisonProductCarousel2 = _interopRequireDefault(_ComparisonProductCarousel);

var _icon_arrow_down = __webpack_require__(988);

var _icon_arrow_down2 = _interopRequireDefault(_icon_arrow_down);

var _utilities = __webpack_require__(51);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'comparison-body',
  props: ['nid', 'cover'],
  components: {
    AuthorPane: _AuthorPane2.default,
    SharePane: _SharePane2.default,
    ProductPane: _ProductPane2.default,
    NodeLink: _Link2.default,
    NodeLabel: _Label2.default,
    Tag: _Tag2.default,
    FieldBody: _Body2.default,
    ArticleHeader: _ArticleHeader2.default,
    InlineNewsletterForm: _InlineNewsletterForm2.default,

    SvgIconArrowDownOne: _icon_arrow_down2.default,
    BodyHead: _BodyHead2.default,
    ComparisonProductCarousel: _ComparisonProductCarousel2.default
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    getNewsLetterType: function getNewsLetterType() {
      return (0, _utilities.getNewsLetterMapping)((0, _get2.default)(this, 'node.sections', {}));
    },
    products: function products() {
      var _this = this;

      var mappedProducts = [];
      (0, _forEach2.default)((0, _get2.default)(this, 'node.product_collection', []), function (product) {
        var mappedProduct = (0, _clone2.default)(product);
        mappedProduct.product = _this.$store.getters.node(mappedProduct.product);
        mappedProducts.push(mappedProduct);
      });
      return mappedProducts;
    }
  },
  data: function data() {
    return {
      bodyOptions: {
        countDown: false,
        photoOverlay: true,
        inlineNewsletter: false
      }
    };
  },
  mounted: function mounted() {
    _eventBus2.default.$emit('nodeBodyMounted');
  }
};

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _imageOrientation = __webpack_require__(1184);

var _imageOrientation2 = _interopRequireDefault(_imageOrientation);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'comparison-product-carousel',
  props: ['products'],
  directives: {
    ImageOrientation: _imageOrientation2.default
  },
  data: function data() {
    return {
      startX: 0,
      originalScrollX: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var passive = (0, _utilities.supportPassive)() ? { passive: true } : false;
    this.$refs.carousel.addEventListener('touchstart', function (e) {
      _this.startX = e.touches[0].clientX;
      _this.originalScrollX = _this.$refs.carousel.scrollLeft;
    }, passive);
    this.$refs.carousel.addEventListener('touchmove', function (e) {
      var targetX = _this.originalScrollX + (_this.startX - e.touches[0].clientX);
      if (targetX < 0 || targetX > _this.$refs.carousel.scrollWidth - _this.$refs.carousel.offsetWidth) {
        if (targetX < 0) {
          _this.$refs.carousel.scrollLeft = 0;
        } else {
          _this.$refs.carousel.scrollLeft = _this.$refs.carousel.scrollWidth - _this.$refs.carousel.offsetWidth;
        }
        _this.startX = e.touches[0].clientX;
        _this.originalScrollX = _this.$refs.carousel.scrollLeft;
        return;
      }
      _this.$refs.carousel.scrollLeft = targetX;
    }, passive);
  },

  methods: {
    image: function image(product) {
      var originalProductImage = (0, _get2.default)(product, 'product.images[0].style_650w', '');
      var comparisonProductImage = (0, _get2.default)(product, 'images[0].style_650w', '');
      return comparisonProductImage !== '' ? comparisonProductImage : originalProductImage;
    }
  }
};

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".product-carousel-wrapper[data-v-011d0170]{overflow:hidden;position:relative;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.product-carousel-wrapper[data-v-011d0170]::-webkit-scrollbar{display:none}.product-carousel-wrapper .product-carousel-horizontal-line[data-v-011d0170]{z-index:2;height:2px;width:100%;background-color:#00e8ff;position:absolute;top:3.1875rem}.product-carousel-wrapper .product-carousel[data-v-011d0170]{z-index:3;display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;padding:0}@media (min-width:1024px){.product-carousel-wrapper .product-carousel[data-v-011d0170]{padding-bottom:2.0625rem}}.product-carousel-wrapper .product-carousel-item[data-v-011d0170]{display:inline-block;margin-right:.75rem;width:6.375rem}.product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border[data-v-011d0170]{height:6.375rem;width:6.375rem;background-color:#fff;border:1px solid #00e8ff;border-radius:50%;overflow:hidden;padding-top:1rem;position:relative}.product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border img.landscape[data-v-011d0170],.product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border img.square[data-v-011d0170]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);max-width:9.0625rem}.product-carousel-wrapper .product-carousel-item .product-carousel-item-title[data-v-011d0170]{font-size:.75rem;line-height:.8125rem;color:#f8008e;font-weight:700;display:block;text-align:center;margin-top:.75rem}.product-carousel-wrapper .product-carousel-item img[data-v-011d0170]{max-width:4.375rem;max-height:9.0625rem;width:auto;display:block;margin:0 auto}.product-carousel-wrapper .product-carousel-item[data-v-011d0170]:first-child{margin-left:.75rem}.product-carousel-wrapper .product-carousel-item[data-v-011d0170]:after{display:block;content:\"\";height:2px;width:7.875rem;margin-left:-.75rem;background-color:#00e8ff;position:absolute;top:3.1875rem;z-index:-1}", "", {"version":3,"sources":["/app/components/node/comparison/ComparisonProductCarousel.vue"],"names":[],"mappings":"AAgCA,2CACE,gBAAiB,AACjB,kBAAmB,AACnB,wBAAyB,AACzB,6BAA+B,CAChC,AACD,8DACI,YAAc,CACjB,AACD,6EACI,UAAW,AACX,WAAY,AACZ,WAAY,AACZ,yBAA0B,AAC1B,kBAAmB,AACnB,aAAe,CAClB,AACD,6DACI,UAAW,AACX,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,SAAW,CAEd,AACD,0BACA,6DACQ,wBAA0B,CACjC,CACA,AACD,kEACI,qBAAsB,AACtB,oBAAsB,AACtB,cAAgB,CACnB,AACD,uGACM,gBAAiB,AACjB,eAAgB,AAChB,sBAA0B,AAC1B,yBAA0B,AAC1B,kBAAmB,AACnB,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACxB,AACD,uOACQ,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACrC,mCAAqC,AACjC,+BAAiC,AACzC,mBAAqB,CAC5B,AACD,+FACM,iBAAmB,AACnB,qBAAuB,AACvB,cAAe,AACf,gBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,iBAAoB,CACzB,AACD,sEACM,mBAAoB,AACpB,qBAAsB,AACtB,WAAY,AACZ,cAAe,AACf,aAAe,CACpB,AACD,8EACM,kBAAqB,CAC1B,AACD,wEACM,cAAe,AACf,WAAY,AACZ,WAAY,AACZ,eAAgB,AAChB,oBAAsB,AACtB,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,UAAY,CACjB","file":"ComparisonProductCarousel.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.product-carousel-wrapper[data-v-011d0170] {\n  overflow: hidden;\n  position: relative;\n  -ms-overflow-style: none;\n  overflow: -moz-scrollbars-none;\n}\n.product-carousel-wrapper[data-v-011d0170]::-webkit-scrollbar {\n    display: none;\n}\n.product-carousel-wrapper .product-carousel-horizontal-line[data-v-011d0170] {\n    z-index: 2;\n    height: 2px;\n    width: 100%;\n    background-color: #00E8FF;\n    position: absolute;\n    top: 3.1875rem;\n}\n.product-carousel-wrapper .product-carousel[data-v-011d0170] {\n    z-index: 3;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    position: relative;\n    padding: 0;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-carousel-wrapper .product-carousel[data-v-011d0170] {\n        padding-bottom: 2.0625rem;\n}\n}\n.product-carousel-wrapper .product-carousel-item[data-v-011d0170] {\n    display: inline-block;\n    margin-right: 0.75rem;\n    width: 6.375rem;\n}\n.product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border[data-v-011d0170] {\n      height: 6.375rem;\n      width: 6.375rem;\n      background-color: #FFFFFF;\n      border: 1px solid #00E8FF;\n      border-radius: 50%;\n      overflow: hidden;\n      padding-top: 1rem;\n      position: relative;\n}\n.product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border img.landscape[data-v-011d0170], .product-carousel-wrapper .product-carousel-item .product-carousel-item-circle-border img.square[data-v-011d0170] {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        -webkit-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n                transform: translate(-50%, -50%);\n        max-width: 9.0625rem;\n}\n.product-carousel-wrapper .product-carousel-item .product-carousel-item-title[data-v-011d0170] {\n      font-size: 0.75rem;\n      line-height: 0.8125rem;\n      color: #F8008E;\n      font-weight: bold;\n      display: block;\n      text-align: center;\n      margin-top: 0.75rem;\n}\n.product-carousel-wrapper .product-carousel-item img[data-v-011d0170] {\n      max-width: 4.375rem;\n      max-height: 9.0625rem;\n      width: auto;\n      display: block;\n      margin: 0 auto;\n}\n.product-carousel-wrapper .product-carousel-item[data-v-011d0170]:first-child {\n      margin-left: 0.75rem;\n}\n.product-carousel-wrapper .product-carousel-item[data-v-011d0170]:after {\n      display: block;\n      content: '';\n      height: 2px;\n      width: 7.875rem;\n      margin-left: -0.75rem;\n      background-color: #00E8FF;\n      position: absolute;\n      top: 3.1875rem;\n      z-index: -1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "@media (min-width:1024px){.product-pane .specification{max-width:15rem}}@media (min-width:0) and (max-width:1023px){.product-pane .specification{padding:0 1.25rem}}@media (min-width:0) and (max-width:1023px){.product-pane .product-description{margin-bottom:1.75rem}}.product-pane .product-description>:last-child{margin-bottom:0}", "", {"version":3,"sources":["/app/components/node/ProductPane.vue"],"names":[],"mappings":"AAoCA,0BACA,6BACM,eAAiB,CACtB,CACA,AACD,4CACA,6BACM,iBAAmB,CACxB,CACA,AAID,4CACA,mCACM,qBAAuB,CAC5B,CACA,AACD,+CACI,eAAiB,CACpB","file":"ProductPane.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.product-pane .specification {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-pane .specification {\n      max-width: 15rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.product-pane .specification {\n      padding: 0 1.25rem;\n}\n}\n.product-pane .product-description {\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.product-pane .product-description {\n      margin-bottom: 1.75rem;\n}\n}\n.product-pane .product-description > *:last-child {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "@media (min-width:1024px){.product-content-row[data-v-4c197b97]{margin-bottom:2.5rem}}@media (min-width:0) and (max-width:1023px){.product-content-row[data-v-4c197b97]{margin-bottom:1.75rem}}@media (min-width:1024px){.product-pane[data-v-4c197b97]{padding-top:1.75rem}}.product-slogan[data-v-4c197b97]{font-family:Barlow,sans-serif;font-size:1rem;line-height:1.1875rem;font-weight:700;color:#f8008e;text-transform:uppercase;margin-bottom:.5rem}@media (min-width:1024px){.product-slogan[data-v-4c197b97]{font-size:1.25rem;line-height:1.625rem;margin-bottom:.375rem}}.product-title[data-v-4c197b97]{font-size:1.75rem;line-height:2.0625rem;color:#002e3e;margin-bottom:.25rem}@media (min-width:1024px){.product-header[data-v-4c197b97]{max-width:16.875rem}}@media (min-width:0) and (max-width:1023px){.product-header[data-v-4c197b97]{text-align:center}}.product-rating[data-v-4c197b97]{margin-top:-1.125rem;margin-bottom:2.3125rem}.product-review-btn[data-v-4c197b97]{margin-top:1.75rem;font-size:.875rem;line-height:1.5rem;font-weight:700;text-transform:uppercase;padding:0 2.375rem;background-color:#f8008e;color:#fff;display:inline-block}.product-image[data-v-4c197b97]{width:auto}.product-description[data-v-4c197b97]{font-size:1.125rem;line-height:1.625rem}@media (min-width:1024px){.image-holder-wrapper[data-v-4c197b97]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.image-holder-wrapper .image-holder .product-image[data-v-4c197b97]{max-width:85%;max-height:25rem}@media (min-width:1024px){.image-holder-wrapper .image-holder[data-v-4c197b97]{text-align:left}.image-holder-wrapper .image-holder.square[data-v-4c197b97]{height:100%;width:100%}.image-holder-wrapper .image-holder.square img[data-v-4c197b97]{width:100%}}@media (min-width:0) and (max-width:1023px){.image-holder-wrapper .image-holder[data-v-4c197b97]{text-align:center}.image-holder-wrapper .image-holder.landscape[data-v-4c197b97],.image-holder-wrapper .image-holder.square[data-v-4c197b97]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.image-holder-wrapper .image-holder.landscape img[data-v-4c197b97],.image-holder-wrapper .image-holder.square img[data-v-4c197b97]{padding-left:1.25rem;padding-right:1.25rem}}", "", {"version":3,"sources":["/app/components/node/ProductPane.vue"],"names":[],"mappings":"AAoCA,0BACA,sCACM,oBAAsB,CAC3B,CACA,AACD,4CACA,sCACM,qBAAuB,CAC5B,CACA,AAID,0BACA,+BACM,mBAAqB,CAC1B,CACA,AACD,iCACE,8BAAkC,AAClC,eAAgB,AAChB,sBAAuB,AACvB,gBAAkB,AAClB,cAAe,AACf,yBAA0B,AAC1B,mBAAsB,CAEvB,AACD,0BACA,iCACM,kBAAmB,AACnB,qBAAsB,AACtB,qBAAwB,CAC7B,CACA,AACD,gCACE,kBAAmB,AACnB,sBAAuB,AACvB,cAAe,AACf,oBAAuB,CACxB,AAKD,0BACA,iCACM,mBAAqB,CAC1B,CACA,AACD,4CACA,iCACM,iBAAmB,CACxB,CACA,AACD,iCACE,qBAAsB,AACtB,uBAAyB,CAC1B,AACD,qCACE,mBAAoB,AACpB,kBAAoB,AACpB,mBAAoB,AACpB,gBAAkB,AAClB,yBAA0B,AAC1B,mBAAoB,AACpB,yBAA0B,AAC1B,WAAe,AACf,oBAAsB,CACvB,AACD,gCACE,UAAY,CACb,AACD,sCACE,mBAAoB,AACpB,oBAAsB,CACvB,AAID,0BACA,uCACM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,CACA,AAKD,oEACM,cAAe,AACf,gBAAkB,CACvB,AACD,0BACA,qDACQ,eAAiB,CACxB,AACD,4DACU,YAAa,AACb,UAAY,CACrB,AACD,gEACY,UAAY,CACvB,CACA,AACD,4CACA,qDACQ,iBAAmB,CAC1B,AACD,2HACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,mIACY,qBAAsB,AACtB,qBAAuB,CAClC,CACA","file":"ProductPane.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.product-content-row[data-v-4c197b97] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-content-row[data-v-4c197b97] {\n      margin-bottom: 2.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.product-content-row[data-v-4c197b97] {\n      margin-bottom: 1.75rem;\n}\n}\n.product-pane[data-v-4c197b97] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-pane[data-v-4c197b97] {\n      padding-top: 1.75rem;\n}\n}\n.product-slogan[data-v-4c197b97] {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 1rem;\n  line-height: 1.1875rem;\n  font-weight: bold;\n  color: #F8008E;\n  text-transform: uppercase;\n  margin-bottom: 0.5rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-slogan[data-v-4c197b97] {\n      font-size: 1.25rem;\n      line-height: 1.625rem;\n      margin-bottom: 0.375rem;\n}\n}\n.product-title[data-v-4c197b97] {\n  font-size: 1.75rem;\n  line-height: 2.0625rem;\n  color: #002E3E;\n  margin-bottom: 0.25rem;\n}\n.product-header[data-v-4c197b97] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.product-header[data-v-4c197b97] {\n      max-width: 16.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.product-header[data-v-4c197b97] {\n      text-align: center;\n}\n}\n.product-rating[data-v-4c197b97] {\n  margin-top: -1.125rem;\n  margin-bottom: 2.3125rem;\n}\n.product-review-btn[data-v-4c197b97] {\n  margin-top: 1.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 0 2.375rem;\n  background-color: #F8008E;\n  color: #FFFFFF;\n  display: inline-block;\n}\n.product-image[data-v-4c197b97] {\n  width: auto;\n}\n.product-description[data-v-4c197b97] {\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n}\n.image-holder-wrapper[data-v-4c197b97] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.image-holder-wrapper[data-v-4c197b97] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n}\n.image-holder-wrapper .image-holder[data-v-4c197b97] {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n.image-holder-wrapper .image-holder .product-image[data-v-4c197b97] {\n      max-width: 85%;\n      max-height: 25rem;\n}\n@media (min-width: 1024px) {\n.image-holder-wrapper .image-holder[data-v-4c197b97] {\n        text-align: left;\n}\n.image-holder-wrapper .image-holder.square[data-v-4c197b97] {\n          height: 100%;\n          width: 100%;\n}\n.image-holder-wrapper .image-holder.square img[data-v-4c197b97] {\n            width: 100%;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.image-holder-wrapper .image-holder[data-v-4c197b97] {\n        text-align: center;\n}\n.image-holder-wrapper .image-holder.landscape[data-v-4c197b97], .image-holder-wrapper .image-holder.square[data-v-4c197b97] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.image-holder-wrapper .image-holder.landscape img[data-v-4c197b97], .image-holder-wrapper .image-holder.square img[data-v-4c197b97] {\n            padding-left: 1.25rem;\n            padding-right: 1.25rem;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".node-type-comparison .body-head .head-title{margin-bottom:2.0625rem}@media (min-width:1024px){.node-type-comparison .article-body{font-size:1.25rem;line-height:1.875rem}}@media (min-width:0) and (max-width:1023px){.node-type-comparison .article-body{margin-bottom:0}}.node-type-comparison .article-body div[class$=-wrapper]{margin-bottom:1.75rem;text-align:center}@media (min-width:1024px){.node-type-comparison .article-body iframe{margin:0 auto 2rem}}@media (min-width:0) and (max-width:1023px){.node-type-comparison .article-body iframe{margin-top:0;margin-left:auto;margin-right:auto;margin-bottom:1.75rem!important}}.node-type-comparison .article-body>:last-child{margin-bottom:0}.node-type-comparison .article-body iframe,.node-type-comparison .article-body img{max-width:100%}.node-type-comparison .article-body img{height:auto}.node-type-comparison .share-buttons-wrapper .share-button svg{fill:#f8008e}", "", {"version":3,"sources":["/app/components/node/comparison/ComparisonBody.vue"],"names":[],"mappings":"AAgCA,6CACE,uBAAyB,CAC1B,AAKD,0BACA,oCACM,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,4CACA,oCACM,eAAiB,CACtB,CACA,AACD,yDACI,sBAAuB,AACvB,iBAAmB,CACtB,AAKD,0BACA,2CAEQ,kBAAkB,CAGzB,CACA,AACD,4CACA,2CACQ,aAAc,AACd,iBAAkB,AAClB,kBAAmB,AACnB,+BAAkC,CACzC,CACA,AACD,gDACI,eAAiB,CACpB,AACD,mFACI,cAAgB,CACnB,AACD,wCACI,WAAa,CAChB,AACD,+DACE,YAAc,CACf","file":"ComparisonBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.node-type-comparison .body-head .head-title {\n  margin-bottom: 2.0625rem;\n}\n.node-type-comparison .article-body {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-comparison .article-body {\n      font-size: 1.25rem;\n      line-height: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.node-type-comparison .article-body {\n      margin-bottom: 0;\n}\n}\n.node-type-comparison .article-body div[class$=\"-wrapper\"] {\n    margin-bottom: 1.75rem;\n    text-align: center;\n}\n.node-type-comparison .article-body iframe {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.node-type-comparison .article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 2rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.node-type-comparison .article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 1.75rem !important;\n}\n}\n.node-type-comparison .article-body > *:last-child {\n    margin-bottom: 0;\n}\n.node-type-comparison .article-body iframe, .node-type-comparison .article-body img {\n    max-width: 100%;\n}\n.node-type-comparison .article-body img {\n    height: auto;\n}\n.node-type-comparison .share-buttons-wrapper .share-button svg {\n  fill: #F8008E;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".newsletter-wrapper[data-v-ed1cd01e]{padding-top:.75rem}@media (min-width:1024px){.divider[data-v-ed1cd01e]{border-bottom:2px solid #ccc;padding-top:.75rem;margin-bottom:.75rem}}.node-type-comparison[data-v-ed1cd01e]{background-color:#fff}.node-type-comparison .article-content-wrapper[data-v-ed1cd01e]{font-family:Roboto,sans-serif}figcaption[data-v-ed1cd01e]{font-size:.875rem;line-height:1rem;color:#999;margin-top:.625rem}.follow-instagram[data-v-ed1cd01e]{text-align:center}@media (min-width:1024px){.follow-instagram[data-v-ed1cd01e]{padding-top:2.5rem}}.follow-instagram svg[data-v-ed1cd01e]{width:100%}.follow-instagram a[data-v-ed1cd01e]{display:inline-block}@media (min-width:1024px){.article-parent-wrapper[data-v-ed1cd01e]{padding-top:2.5rem}}.article-content-wrapper[data-v-ed1cd01e]{background-color:#fff;color:#222;font-size:1.125rem;line-height:1.625rem;padding-bottom:1.75rem}@media (min-width:0) and (max-width:1023px){.article-content-wrapper[data-v-ed1cd01e]{padding-left:1.25rem;padding-right:1.25rem}}.article-summary[data-v-ed1cd01e]{font-weight:700}@media (min-width:1024px){.article-summary[data-v-ed1cd01e]{font-size:1.5rem;line-height:2.125rem}}@media (min-width:0) and (max-width:1023px){.article-body-wrapper[data-v-ed1cd01e]{padding-top:1.75rem}}.tags-wrapper[data-v-ed1cd01e]{position:relative;padding:1.75rem .4375rem .9375rem;border-top:1px solid #979797;font-family:Barlow,sans-serif}.comment-wrapper[data-v-ed1cd01e]{position:relative;margin-top:1.75rem}@media (min-width:1024px){.comment-wrapper[data-v-ed1cd01e]{position:absolute;top:0;left:-15.625rem}}.comment-wrapper .comment-count[data-v-ed1cd01e]{position:absolute;left:0;top:0;color:#fff;font-size:18px;line-height:41px;max-width:172px;width:100%;text-align:center;text-transform:uppercase}", "", {"version":3,"sources":["/app/components/node/comparison/ComparisonBody.vue"],"names":[],"mappings":"AAgCA,qCACE,kBAAqB,CACtB,AAID,0BACA,0BACM,6BAAiC,AACjC,mBAAqB,AACrB,oBAAuB,CAC5B,CACA,AACD,uCACE,qBAA0B,CAC3B,AACD,gEACI,6BAAkC,CACrC,AACD,4BACE,kBAAoB,AACpB,iBAAkB,AAClB,WAAe,AACf,kBAAqB,CACtB,AACD,mCACE,iBAAmB,CAEpB,AACD,0BACA,mCACM,kBAAoB,CACzB,CACA,AACD,uCACI,UAAY,CACf,AACD,qCACI,oBAAsB,CACzB,AAID,0BACA,yCACM,kBAAoB,CACzB,CACA,AACD,0CACE,sBAA0B,AAC1B,WAAe,AACf,mBAAoB,AACpB,qBAAsB,AACtB,sBAAwB,CAEzB,AACD,4CACA,0CACM,qBAAsB,AACtB,qBAAuB,CAC5B,CACA,AACD,kCACE,eAAkB,CAEnB,AACD,0BACA,kCACM,iBAAkB,AAClB,oBAAsB,CAC3B,CACA,AAID,4CACA,uCACM,mBAAqB,CAC1B,CACA,AACD,+BACE,kBAAmB,AACnB,kCAAqC,AACrC,6BAA8B,AAC9B,6BAAkC,CACnC,AACD,kCAEE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,0BACA,kCACM,kBAAmB,AACnB,MAAO,AACP,eAAiB,CACtB,CACA,AACD,iDACI,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,eAAgB,AAChB,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,kBAAmB,AACnB,wBAA0B,CAC7B","file":"ComparisonBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter-wrapper[data-v-ed1cd01e] {\n  padding-top: 0.75rem;\n}\n.divider[data-v-ed1cd01e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.divider[data-v-ed1cd01e] {\n      border-bottom: 2px solid #cccccc;\n      padding-top: 0.75rem;\n      margin-bottom: 0.75rem;\n}\n}\n.node-type-comparison[data-v-ed1cd01e] {\n  background-color: #FFFFFF;\n}\n.node-type-comparison .article-content-wrapper[data-v-ed1cd01e] {\n    font-family: \"Roboto\", sans-serif;\n}\nfigcaption[data-v-ed1cd01e] {\n  font-size: 0.875rem;\n  line-height: 1rem;\n  color: #999999;\n  margin-top: 0.625rem;\n}\n.follow-instagram[data-v-ed1cd01e] {\n  text-align: center;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.follow-instagram[data-v-ed1cd01e] {\n      padding-top: 2.5rem;\n}\n}\n.follow-instagram svg[data-v-ed1cd01e] {\n    width: 100%;\n}\n.follow-instagram a[data-v-ed1cd01e] {\n    display: inline-block;\n}\n.article-parent-wrapper[data-v-ed1cd01e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-parent-wrapper[data-v-ed1cd01e] {\n      padding-top: 2.5rem;\n}\n}\n.article-content-wrapper[data-v-ed1cd01e] {\n  background-color: #FFFFFF;\n  color: #222222;\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n  padding-bottom: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-content-wrapper[data-v-ed1cd01e] {\n      padding-left: 1.25rem;\n      padding-right: 1.25rem;\n}\n}\n.article-summary[data-v-ed1cd01e] {\n  font-weight: bold;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-summary[data-v-ed1cd01e] {\n      font-size: 1.5rem;\n      line-height: 2.125rem;\n}\n}\n.article-body-wrapper[data-v-ed1cd01e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body-wrapper[data-v-ed1cd01e] {\n      padding-top: 1.75rem;\n}\n}\n.tags-wrapper[data-v-ed1cd01e] {\n  position: relative;\n  padding: 1.75rem 0.4375rem 0.9375rem;\n  border-top: 1px solid #979797;\n  font-family: \"Barlow\", sans-serif;\n}\n.comment-wrapper[data-v-ed1cd01e] {\n  /* Mobile breakpoints */\n  position: relative;\n  margin-top: 1.75rem;\n}\n@media (min-width: 1024px) {\n.comment-wrapper[data-v-ed1cd01e] {\n      position: absolute;\n      top: 0;\n      left: -15.625rem;\n}\n}\n.comment-wrapper .comment-count[data-v-ed1cd01e] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    color: #FFF;\n    font-size: 18px;\n    line-height: 41px;\n    max-width: 172px;\n    width: 100%;\n    text-align: center;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("7f102032", content, true, {});

/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("5b05645e", content, true, {});

/***/ }),

/***/ 1582:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1493);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("97b01f1e", content, true, {});

/***/ }),

/***/ 1634:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1545);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("173adfd1", content, true, {});

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("a04b972e", content, true, {});

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(237),
    baseRest = __webpack_require__(109),
    isArrayLikeObject = __webpack_require__(149);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1581)
  __webpack_require__(1582)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1364),
  /* template */
  __webpack_require__(1746),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c197b97",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1710:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1634)
  __webpack_require__(1635)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1376),
  /* template */
  __webpack_require__(1793),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed1cd01e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1377),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-011d0170",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1721:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "carousel",
    staticClass: "product-carousel-wrapper no-article-gutter-mobile no-article-swipe"
  }, [(_vm.products) ? _c('div', {
    staticClass: "product-carousel-horizontal-line no-mobile-article-gutter"
  }) : _vm._e(), _c('div', {
    staticClass: "product-carousel"
  }, _vm._l((_vm.products), function(product, index) {
    return (product) ? _c('a', {
      staticClass: "product-carousel-item",
      attrs: {
        "href": ("#product-" + index)
      }
    }, [_c('div', {
      staticClass: "product-carousel-item-circle-border"
    }, [_c('img', {
      directives: [{
        name: "image-orientation",
        rawName: "v-image-orientation"
      }, {
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.image(product)),
        expression: "image(product)"
      }]
    })]), _c('span', {
      staticClass: "product-carousel-item-title"
    }, [_vm._v(_vm._s(product.product.title))])]) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 1746:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-type-product product-pane row row-reverse"
  }, [_c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row row-reverse product-content-row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-7"
  }, [_c('div', {
    staticClass: "product-header text-center"
  }, [_c('div', {
    staticClass: "product-slogan"
  }, [_vm._v(_vm._s(_vm.product.slogan))]), _c('h1', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.product.title))]), (_vm.product.rating) ? _c('div', {
    staticClass: "product-rating"
  }, [_c('span', {
    staticClass: "product-score"
  }, [_vm._v(_vm._s(_vm.product.rating))]), _vm._v("/5")]) : _vm._e(), (_vm.reviewArticleNode) ? _c('a', {
    staticClass: "product-review-btn hidden-xs-down",
    attrs: {
      "href": _vm.reviewArticleNode.relative_url
    }
  }, [_vm._v("read our review")]) : _vm._e()])]), _c('div', {
    staticClass: "col-12 col-sm-5 text-center image-holder-wrapper"
  }, [_c('div', {
    directives: [{
      name: "image-orientation",
      rawName: "v-image-orientation",
      value: ('wrapper'),
      expression: "'wrapper'"
    }],
    staticClass: "image-holder"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.image),
      expression: "image"
    }],
    staticClass: "product-image",
    attrs: {
      "alt": _vm.product.product.title
    }
  })]), (_vm.reviewArticleNode) ? _c('a', {
    staticClass: "product-review-btn hidden-sm-up",
    attrs: {
      "href": _vm.reviewArticleNode.relative_url
    }
  }, [_vm._v("read our review")]) : _vm._e()])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "product-description",
    domProps: {
      "innerHTML": _vm._s(_vm.product.body)
    }
  })])])]), _c('div', {
    staticClass: "col-sm-4 col-12"
  }, [(_vm.properties) ? _c('specification-pane', {
    attrs: {
      "properties": _vm.properties
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1793:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "node node-type-comparison"
  }, [_c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('article-header', {
    staticClass: "hidden-sm-up",
    attrs: {
      "node": _vm.node
    }
  }), _c('div', {
    staticClass: "container article-content-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-12"
  }, [_c('author-pane', {
    attrs: {
      "node": _vm.node
    }
  }), _c('share-pane', {
    attrs: {
      "node": _vm.node
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('comparison-product-carousel', {
    staticClass: "hidden-sm-up",
    attrs: {
      "products": _vm.products
    }
  }), _c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('body-head', {
    attrs: {
      "node": _vm.node
    }
  }), _c('comparison-product-carousel', {
    staticClass: "hidden-md-down",
    attrs: {
      "products": _vm.products
    }
  }), _c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1)], 1)])]), _vm._l((_vm.products), function(product, index) {
    return [(index === 0) ? _c('div', {
      staticClass: "divider w-100"
    }) : _vm._e(), _c('div', {
      staticClass: "container article-content-wrapper"
    }, [(product) ? _c('product-pane', {
      key: index,
      attrs: {
        "id": ("product-" + index),
        "product": product
      }
    }) : _vm._e()], 1), (index === 1) ? _c('div', {
      staticClass: "container newsletter-wrapper no-article-gutter-mobile hidden-md-up"
    }, [_c('div', {
      staticClass: "col-sm-8 offset-sm-4"
    }, [_c('div', {
      staticClass: "newsletter-form-wrapper"
    }, [_c('inline-newsletter-form', {
      attrs: {
        "newsletterType": _vm.getNewsLetterType,
        "theme": 'white'
      }
    })], 1)])]) : _vm._e(), ((index + 1 != _vm.products.length)) ? _c('div', {
      staticClass: "divider w-100"
    }) : _vm._e()]
  }), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-12"
  }), _c('div', {
    staticClass: "col-12 col-sm-8"
  }, [_c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('div', {
    staticClass: "tags-wrapper"
  }, [_c('tag', {
    attrs: {
      "node": _vm.node
    }
  })], 1)])])])])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1128),
  /* template */
  __webpack_require__(1179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73e7b9c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 25.e6de7c7ead46baaa8526.js